export default {
  required: "${label} اجباری است",
};
